Confirm = require 'views/lib/confirm'
ListBulkMoveCardsView = require 'views/list/list-bulk-move-cards-view'
ListCopyView = require 'views/list/list-copy-view'
ListMoveView = require 'views/list/list-move-view'
ListSetLimitView = require 'views/list/list-set-limit-view'
ListSortView = require 'views/list/list-sort-view'
PluginIOCache = require 'views/internal/plugins/plugin-io-cache'
PluginRunner = require 'views/internal/plugins/plugin-runner'
PluginView = require 'views/plugin/plugin-view'
getExperiment = require 'lib/experiments/simple-test'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'lib/util'
template = require 'views/templates/list_menu'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
_ = require 'underscore'

module.exports = class ListMenuView extends PluginView
  viewTitleKey: 'list actions'

  initialize: ->
    @listenTo @model, 'change:subscribed', @frameDebounce @render
    @retain @options.pluginActions

  events:
    'click .js-add-card': 'addCard'
    'click .js-move-list': 'moveList'
    'click .js-copy-list': 'copyList'
    'click .js-list-subscribe': 'toggleSubscribe'

    'click .js-move-cards': 'moveCards'
    'click .js-archive-cards': 'archiveCards'

    'mouseenter .js-sort-cards': 'preloadSortBy'
    'click .js-sort-cards': 'sortBy'

    'click .js-close-list': 'closeList'

    'click .js-plugin-list-action': 'runPluginAction'

    'click .js-set-list-limit': 'setListLimit'

  render: ->
    # EXPERIMENT: subscribeToWatchOrFollow
    subscribeToWatchOrFollow = getExperiment 'subscribeToWatchOrFollow'
    subscribeString = 'subscribe'
    if subscribeToWatchOrFollow?.inExperiment and subscribeToWatchOrFollow.get('variation') != 'control'
      subscribeString = subscribeToWatchOrFollow.get('variation')

    @pluginActions = _.chain(@options.pluginActions)
      .filter (a) ->
        _.isString(a.text) &&
        a.text.length &&
        _.isFunction(a.callback)
      .map (a) ->
        _.extend(a, {
          icon: PluginIOCache.fromId(a.idPlugin).getIconUrl()
          name: PluginIOCache.fromId(a.idPlugin).getName()
        })
      .sortBy('text')
      .value()

    @$el.html(template({
      editable: @model.editable()
      hasSortableCards: @model.cardList.length > 1
      subscribed: @model.get('subscribed')
      canCopyList: !@model.isOverLimit('lists', 'totalPerBoard') &&
      !@model.isOverLimit('lists', 'openPerBoard')
      subscribeString: subscribeString
      pluginActions: @pluginActions
      listLimitsEnabled: @model.getBoard().isListLimitsPowerUpEnabled()
    }))

    @

  addCard: (e) ->
    Util.stop(e)

    PopOver.hide()

    @model.getBoard().composer.save({
      list: @model
      index: 0
      vis: true
    })

    track("List Menu", "Add Card")
    track('Card Composer', 'Open', 'Via List Menu')

    return

  moveList: (e) ->
    Util.stop(e)

    track("List Menu", "Open Move List Popover")
    PopOver.pushView
      view: new ListMoveView({ @model, @modelCache })

    return

  copyList: (e) ->
    Util.stop(e)

    track("List Menu", "Open Copy List Popover")
    PopOver.pushView
      view: new ListCopyView({ @model, @modelCache })

    return

  toggleSubscribe: (e) ->
    Util.preventDefault(e)
    if @model.get('subscribed')
      @model.subscribe(false)
      track("List Menu", "Subscribe", "Unsubscribe")
    else
      @model.subscribe(true)
      track("List Menu", "Subscribe", "Subscribe")
    return

  moveCards: (e) ->
    Util.stop(e)
    track("List Menu", "Open Move All Cards in List")

    PopOver.pushView
      view: new ListBulkMoveCardsView({ @model, @modelCache })

    return

  archiveCards: (e) ->
    Util.stop(e)
    track("List Menu", "Open Archive All Cards in List")

    Confirm.pushView 'archive all cards',
      model: @model
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        PopOver.hide()

        openCards = _.clone(@model.cardList.models)
        for card in openCards
          card.set({ closed: true })

        @model.run 'archiveAllCards',
          {},
          @listViewListen

    return

  loadPluginSorters: (timeout) ->
    PluginRunner.all
      command: 'list-sorters'
      board: @model.getBoard()
      list: @model
      timeout: timeout
    .catch ->
      []
    .then (pluginListSorters) =>
      # limit to 5 sorts per plugin
      limitedSorts = _.chain(pluginListSorters)
        .groupBy('idPlugin')
        .map (val, idPlugin) -> val.slice(0, 5)
        .flatten()
        .value()

  preloadSortBy: (e) ->
    if !@pluginSortersPromise?
      @pluginSortersPromise = @loadPluginSorters(500)
      .then (pluginListSorters) =>
        @pluginSortersPromise = null
        @pluginListSorters = pluginListSorters
        @pluginListSortersExpiry = Date.now() + 5000
        return pluginListSorters

  sortBy: (e) ->
    Util.stop(e)
    track("List Menu", "Open Sort Cards in List")

    pluginListSorters = []

    if @pluginListSorters? && @pluginListSortersExpiry > Date.now()
      pluginListSorters = @pluginListSorters
    else if @pluginSortersPromise?
      pluginListSorters = @pluginSortersPromise
    else
      pluginListSorters = @loadPluginSorters(150)

    Promise.resolve(pluginListSorters)
    .then (pluginListSorters) =>
      PopOver.pushView
        view: new ListSortView({ @model, @modelCache, pluginListSorters })
      @pluginListSorters = null

  setListLimit: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: new ListSetLimitView({ @model, @modelCache })

  runPluginAction: (e) ->
    Util.stop(e)

    target = @pluginActions[@$(e.target).closest('.js-plugin-list-action').data('index')]
    trackUe('list menu', 'opens', 'Power-Up', '', '', 'list-action', target.idPlugin)
    target.callback?({ el: @el, list: @model })

  closeList: (e) ->
    Util.stop(e)

    view = @
    model = @model

    track("List Menu", "Archive List")
    PopOver.hide()
    model.close()

    false



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-menu-view.coffee